import React from 'react';
import { useTranslation } from 'react-i18next';
import HandClockIcon from '../../assets/hand-clock-icon.svg';
import css from './ServiceRequestWidget.module.scss';

export const ServiceRequestWidget: React.FC = () => {
    const { t } = useTranslation('ServiceRequests');

    return (
        <>
            <div className={css.middleContainer}>
                <div className={css.icon}>
                    <HandClockIcon />
                </div>
                <div>{t('Request urgent repairs, additional maintenance')}</div>
                <div>{t('expertise, or swift troubleshooting.')}</div>
            </div>
        </>
    );
};
